import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import styled from 'styled-components';
import { UserContext, isPlatformAdmin } from '../../contexts/UserContext';
import { MainHeading } from '../atoms';
import { withAuthRedirect } from '../hocs';
import type { CommonProps } from '../types/CommonProps';

const OnboardMerchant = ({ className, children }: CommonProps) => (
  <div className={className}>{children}</div>
);
const OnboardMerchantPageBase = () => {
  // Redirect if user isn't admin
  // TODO: maybe we can do this globally
  const { user } = useContext(UserContext);
  if (!isPlatformAdmin(user.userType)) {
    return <Navigate to="/login" replace />;
  }
  return (
    <OnboardMerchant className="onboard-merchant">
      <MainHeading>Onboard your new merchant here...</MainHeading>
    </OnboardMerchant>
  );
};

const OnboardMerchantPage = styled(OnboardMerchantPageBase)`
  color: yellow;
  background-color: pink;
`;

const SecureOnboardMerchantPage = withAuthRedirect(OnboardMerchantPage);
export { SecureOnboardMerchantPage as OnboardMerchantPage };
